<template>
  <transition name="fade">
    <div 
        v-if="realization !== undefined"
        class="zoom-realization">   
        
        <svg
            @click="$emit('close')"
            class="zoom-realization__close"
            width="22px" 
            height="22px" 
            viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="Desktop-HD---Home---Cerca-nel-Sito" transform="translate(-1386.000000, -33.000000)" stroke="#000000" stroke-width="2"><g id="Group-6" transform="translate(1387.000000, 34.000000)"><path d="M10,-2.51207729 L10,22.5120773" id="Line-4" transform="translate(10.000000, 10.000000) rotate(-45.000000) translate(-10.000000, -10.000000) "></path><path d="M10,-2.51207729 L10,22.5120773" id="Line-4" transform="translate(10.000000, 10.000000) rotate(-135.000000) translate(-10.000000, -10.000000) "></path></g></g></g></svg>

        <HeroBackground :srcSetImages="srcSetImages"/>

        <div class="zoom-realization__product-list">
            <h3>{{ realization.fields.didascalia }}</h3>
            <ul>
                <li><p>Prodotti<br> utilizzati:</p></li>
                <li
                    v-for="(product, index) of realization.fields.products"
                    :key="index">
                    <router-link :to="{ name: 'single-product', params: { slug: product.fields.slug } }">
                        <img 
                            :src="`${product.fields.mainPicture.fields.file.url}?h=170&fit=scale`"
                            height="85">
                        <h4>{{ product.fields.title }}</h4>
                    </router-link>
                </li>

            </ul>
        </div>

    </div>
  </transition>
</template>

<script>

import HeroBackground from '@/components/HeroBackground/HeroBackground.vue'

export default {
  name: 'ZoomRealization',
  components: {
    HeroBackground
  },
  props: {
    realization: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    srcSetImages: {
      get () {
        return {
            '640': `${this.realization.fields.image.fields.file.url}?w=640&fit=scale`,
            '1024': `${this.realization.fields.image.fields.file.url}?w=1024&fit=scale`,
            '1440': `${this.realization.fields.image.fields.file.url}?w=1440&fit=scale`,
            '1920': this.realization.fields.image.fields.file.url
        }
      }
    }
  }         
}
</script>

<style lang="scss">
    @import "./zoom.scss";
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
